import { useState } from "react";
import { Flag, CurrencyDollar } from "@phosphor-icons/react";
import { PRIORITIES, fmtMoney } from "./constants";

export function PriorityBadge({ value, onChange, disabled }) {
  const idx = PRIORITIES.findIndex((p) => p.v === (value || ""));
  const cur = PRIORITIES[idx >= 0 ? idx : 0];
  const cycle = () => {
    if (disabled) return;
    const next = PRIORITIES[(idx + 1) % PRIORITIES.length].v;
    onChange(next);
  };
  return (
    <button
      type="button"
      onClick={cycle}
      disabled={disabled}
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold border transition-colors"
      style={{ borderColor: cur.color + "55", color: cur.color, background: cur.color + "12" }}
      title="Click para cambiar prioridad"
      data-testid="priority-badge"
    >
      <Flag size={10} weight="fill" /> {cur.short}
    </button>
  );
}

function ValueEditorInput({ initialValue, initialCurrency, onCommit, onCancel }) {
  const [v, setV] = useState(initialValue);
  const [c, setC] = useState(initialCurrency);
  return (
    <div className="inline-flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
      <select
        value={c}
        onChange={(e) => setC(e.target.value)}
        className="text-[10px] border border-zinc-300 rounded px-1 py-0.5 bg-white"
        data-testid="value-currency"
      >
        <option value="MXN">MX$</option>
        <option value="USD">US$</option>
      </select>
      <input
        type="number"
        autoFocus
        value={v}
        onChange={(e) => setV(e.target.value)}
        onBlur={() => onCommit(v, c)}
        onKeyDown={(e) => { if (e.key === "Enter") onCommit(v, c); if (e.key === "Escape") onCancel(); }}
        className="w-20 text-[11px] numeric border border-zinc-300 rounded px-1 py-0.5"
        data-testid="value-input"
      />
    </div>
  );
}

export function ValueEditor({ value, currency, onSave, disabled }) {
  const [editing, setEditing] = useState(false);
  if (disabled) {
    return Number(value) > 0 ? (
      <span className="text-[11px] numeric font-semibold text-zinc-700 inline-flex items-center gap-0.5">
        <CurrencyDollar size={11} weight="bold" />{fmtMoney(value, currency)}
      </span>
    ) : null;
  }
  if (!editing) {
    return (
      <button
        type="button"
        onClick={() => setEditing(true)}
        className="text-[11px] numeric font-semibold text-zinc-700 hover:text-[#002FA7] inline-flex items-center gap-0.5"
        data-testid="value-display"
        title="Editar valor"
      >
        <CurrencyDollar size={11} weight="bold" />
        {Number(value) > 0 ? fmtMoney(value, currency) : "Añadir valor"}
      </button>
    );
  }
  return (
    <ValueEditorInput
      initialValue={value || 0}
      initialCurrency={currency || "MXN"}
      onCancel={() => setEditing(false)}
      onCommit={async (val, cur) => {
        setEditing(false);
        if (Number(val) !== Number(value) || cur !== currency) {
          await onSave(Number(val) || 0, cur);
        }
      }}
    />
  );
}
